import { Injectable, inject } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { PackageOverviewComponent } from "./package-overview/package-overview.component";

@Injectable({
  providedIn: "root"
})
export class PackageService {
  private readonly dialog = inject(MatDialog);

  showPackageOverviewDialog() {
    this.dialog.open(PackageOverviewComponent);
  }
}
